import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AuthorCard, EmptyState } from "@/components/cards";

export default function Authors() {
  const [authors, setAuthors] = useState([]);
  useEffect(() => { api.get("/authors").then((r) => setAuthors(r.data)); }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-10 fade-in">
      <h1 className="text-4xl md:text-5xl font-display font-bold">Authors</h1>
      <p className="text-muted-foreground mt-2">Meet the storytellers behind your favorite worlds.</p>
      {authors.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
          {authors.map((a) => <AuthorCard key={a.id} author={a} />)}
        </div>
      ) : <div className="mt-10"><EmptyState title="No authors yet" subtitle="Authors will appear here once added in the CMS." /></div>}
    </div>
  );
}
